import React from 'react'
import { useParams } from 'react-router-dom'
import { motion } from 'framer-motion'
import { MessageSquare, ThumbsUp, Reply, Send } from 'lucide-react'

const ThreadPage = () => {
  const { id } = useParams()
  const [content, setContent] = React.useState('')
  const thread = {
    id,
    title: 'Best venues for acoustic performances in Wichita?',
    author: 'Sarah Mitchell',
    lastActivity: '2 hours ago',
    replies: [
      { id: 'r1', author: 'Mike Thunder', text: 'The Cotillion has great sound for acoustic sets.' },
      { id: 'r2', author: 'Jessica Solo', text: 'Kirby\'s open mic is super welcoming.' },
    ]
  }

  const addReply = () => {
    if (!content.trim()) return
    alert('Reply posted (stub).')
    setContent('')
  }

  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-16">
        <div className="container-max max-w-4xl mx-auto">
          <motion.div className="glass-card p-8 mb-6" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <div className="flex items-center justify-between mb-3">
              <h1 className="text-2xl font-display font-bold text-white">{thread.title}</h1>
              <span className="text-white/50 text-sm">{thread.lastActivity}</span>
            </div>
            <div className="text-white/70">Started by {thread.author}</div>
          </motion.div>

          <div className="space-y-4 mb-8">
            {thread.replies.map((r, i) => (
              <motion.div key={r.id} className="glass-card p-6" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: i * 0.05 }} viewport={{ once: true }}>
                <div className="flex items-center justify-between mb-2">
                  <div className="text-white font-medium">{r.author}</div>
                  <div className="flex items-center gap-3 text-white/60 text-sm">
                    <button className="hover:text-white transition-colors"><ThumbsUp size={16} /></button>
                    <button className="hover:text-white transition-colors"><Reply size={16} /></button>
                  </div>
                </div>
                <p className="text-white/80 leading-relaxed">{r.text}</p>
              </motion.div>
            ))}
          </div>

          {/* Composer */}
          <motion.div className="glass-card p-6" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }}>
            <h2 className="text-lg font-display font-semibold text-white mb-3 flex items-center gap-2"><MessageSquare size={18} />Add a Reply</h2>
            <textarea value={content} onChange={(e) => setContent(e.target.value)} rows={5} className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-le-accent" placeholder="Share your experience or advice..." />
            <div className="flex justify-end mt-3">
              <button className="btn-primary flex items-center gap-2" onClick={addReply}><Send size={18} />Post Reply</button>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  )
}

export default ThreadPage

